const WHITE = [255, 255, 255];
const BLACK = [0, 0, 0];

const parseHex = hex => {
  const value = hex.replace('#', '');
  const full =
    value.length === 3
      ? value
          .split('')
          .map(c => c + c)
          .join('')
      : value;
  return [0, 2, 4].map(i => parseInt(full.slice(i, i + 2), 16));
};

const mix = (color, target, amount) =>
  color.map((c, i) => Math.round(c + (target[i] - c) * amount));

const channels = rgb => rgb.join(' ');

const luminance = ([r, g, b]) => (0.299 * r + 0.587 * g + 0.114 * b) / 255;

const palette = (primary, dark) => {
  const base = dark ? mix(primary, WHITE, 0.3) : primary;
  return {
    primary: base,
    'primary-hover': mix(base, WHITE, 0.15),
    'primary-light': dark
      ? mix(primary, BLACK, 0.75)
      : mix(primary, WHITE, 0.9),
    'primary-foreground': luminance(base) > 0.6 ? [15, 26, 28] : WHITE,
    accent: mix(base, WHITE, 0.35),
    ring: mix(base, WHITE, 0.1),
    inverse: luminance(primary) > 0.6 ? mix(primary, BLACK, 0.45) : primary,
    'mock-sidebar': mix(primary, BLACK, 0.4),
    'mock-sidebar-border': mix(primary, BLACK, 0.15),
    'mock-sidebar-active': primary,
    'mock-sidebar-text': mix(primary, WHITE, 0.5),
  };
};

const declarations = colors =>
  Object.entries(colors)
    .map(([name, rgb]) => `--lp-${name}: ${channels(rgb)};`)
    .join('');

export const applyBrandTheme = hex => {
  if (!/^#?[0-9a-f]{3}([0-9a-f]{3})?$/i.test(hex || '')) return;
  const primary = parseHex(hex);
  const style = document.createElement('style');
  style.textContent =
    `:root{${declarations(palette(primary, false))}}` +
    `@media (prefers-color-scheme: dark){:root{${declarations(palette(primary, true))}}}`;
  document.head.appendChild(style);
};
